export default {
    SAVE: "Сохранить",
    CANCEL: "Отменить",
    YOU: "Вы",
    USER_DELETED: "Удалён"
};
